import { render } from "./InvoiceRequestIncomeView.vue?vue&type=template&id=24a3f456"
import script from "./InvoiceRequestIncomeView.vue?vue&type=script&lang=js"
export * from "./InvoiceRequestIncomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__